module.exports = __webpack_public_path__ + "assets/fb2098bef6a2938dda81665f41078fe3.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/bg/video.ogv
// module id = 364
// module chunks = 1